"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMediaReference = parseMediaReference;
exports.filePartFromMediaReference = filePartFromMediaReference;
exports.normalizeMediaPartsFromString = normalizeMediaPartsFromString;
exports.mediaTypeFromDataUri = mediaTypeFromDataUri;
exports.filePartFromUrl = filePartFromUrl;
const types_1 = require("../../../../../utils/IORepresentation/chatML/types");
const json_1 = require("../../utils/json");
// Cheap substring pre-check so token-free strings (nearly all) never pay
// for regex scans.
const MEDIA_TOKEN_HINT = "@@@langfuseMedia";
function parseMediaReference(value) {
    if (typeof value !== "string" || !value.includes(MEDIA_TOKEN_HINT)) {
        return undefined;
    }
    const matches = value.match(types_1.MEDIA_REFERENCE_PATTERN) ?? [];
    if (matches.length !== 1 || matches[0] !== value)
        return undefined;
    const parsed = types_1.MediaReferenceStringSchema.safeParse(value);
    return parsed.success ? parsed.data : undefined;
}
function filePartFromMediaReference(reference, extras) {
    return (0, json_1.compact)({
        type: "file",
        mediaType: reference.type,
        content: { kind: "reference", id: reference.id },
        providerMetadata: (0, json_1.toProviderMetadata)({
            source: reference.source,
            ...extras,
        }),
    });
}
/**
 * Split a string into interleaved text and file parts, one file part per
 * embedded media reference token — strings frequently carry several.
 */
function normalizeMediaPartsFromString(value) {
    if (!value.includes(MEDIA_TOKEN_HINT))
        return [{ type: "text", text: value }];
    const parts = [];
    let lastIndex = 0;
    for (const match of value.matchAll(types_1.MEDIA_REFERENCE_PATTERN)) {
        const parsed = parseMediaReference(match[0]);
        if (!parsed)
            continue; // stays part of the surrounding text
        const before = value.slice(lastIndex, match.index);
        if (before.trim().length > 0)
            parts.push({ type: "text", text: before });
        parts.push(filePartFromMediaReference(parsed));
        lastIndex = match.index + match[0].length;
    }
    if (parts.length === 0)
        return [{ type: "text", text: value }];
    const rest = value.slice(lastIndex);
    if (rest.trim().length > 0)
        parts.push({ type: "text", text: rest });
    return parts;
}
/**
 * Read the media type a data-URI declares in its prefix, without touching
 * the payload. Raw data-URIs only reach stored IO when upstream media
 * processing skipped or failed; decoding them stays the media pipeline's job.
 */
function mediaTypeFromDataUri(url) {
    if (!url.startsWith("data:"))
        return undefined;
    const end = url.slice(5).search(/[;,]/);
    return end > 0 ? url.slice(5, 5 + end) : undefined;
}
/**
 * Media-token check -> data-URI prefix sniff -> plain url. Shared by every
 * url-bearing media field (chat image_url, Responses input_image, Anthropic
 * url sources).
 */
function filePartFromUrl(url, options = {}) {
    const reference = parseMediaReference(url);
    if (reference)
        return filePartFromMediaReference(reference, options.extras);
    return (0, json_1.compact)({
        type: "file",
        mediaType: options.mediaType ??
            mediaTypeFromDataUri(url) ?? // Q: can I not remove this? vercel ai specific
            options.fallbackMediaType,
        content: { kind: "url", url },
        providerMetadata: options.extras
            ? (0, json_1.toProviderMetadata)(options.extras)
            : undefined,
    });
}
